import type { DataSource, ReportBuilderJoin } from './hooks/useReportBuilder';

/** Data sources that support tenant tags via a junction table. */
export const TAG_CAPABLE_SOURCES: readonly DataSource[] = ['contacts'];

/**
 * Pick the table to resolve tags from: main source first, then joins in order.
 */
export function resolveTagSource(
  mainSource: DataSource | '',
  joins: ReportBuilderJoin[] = [],
): DataSource | null {
  if (mainSource && TAG_CAPABLE_SOURCES.includes(mainSource as DataSource)) {
    return mainSource as DataSource;
  }
  for (const join of joins) {
    if (TAG_CAPABLE_SOURCES.includes(join.source)) {
      return join.source;
    }
  }
  return null;
}
